<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Log</li>
          </ol>
        </nav>
      </div>
      <CabeceraInformes
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :idTpv="this.idTpv"
        :listTpv="listTpv"
        :dateto="dateto"
        :datefrom="datefrom"
        id="cabecera"
        :conTodos="true"
      />
      <div class="table-responsive">
        <template v-if="respuesta">
          <table
            class="table table-bordered table-striped tableVentas text-nowrap"
            id="myTable"
          >
            <thead class="thead-dark">
              <tr style="cursor: pointer">
                <th
                  v-if="ordenacionFecha === 0"
                  @click="sortedArrayFechaASC('time')"
                >
                  <i style="color: white" class="fa fa-angle-up"></i>
                  {{ $t("fecha") }}
                </th>
                <th v-else @click="sortedArrayFechaDESC('time')">
                  <i style="color: white" class="fa fa-angle-down"></i>
                  {{ $t("fecha") }}
                </th>
                <th
                  v-if="ordenacionUsuario === 0"
                  @click="sortedArrayUserASC('firstName')"
                >
                  <i style="color: white" class="fa fa-angle-up"></i>
                  {{ $t("usuario") }}
                </th>
                <th v-else @click="sortedArrayUserDESC('firstName')">
                  <i style="color: white" class="fa fa-angle-down"></i>
                  {{ $t("usuario") }}
                </th>
                <th>
                  <i style="color: white" ></i>
                  {{ $t("Incidencia") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="obj in listdatos">
                <td class="text-left">{{ obj.time }}</td>
                <td class="text-left">{{ obj.firstName }}</td>
                <td class="text-left">{{ obj.json }}</td>
              </tr>
            </tbody>
          </table>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ $t("noHay") }} <strong>{{ $t("incidenciaOperario") }}</strong>
            {{ $t("rangoDeFechas") }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Chart from "chart.js";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Loading,
} from "element-ui";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import swal from "sweetalert2";
import moment from "moment";

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", this.$i18n.t("Log"));
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
    this.emitirConsulta();
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    CabeceraInformes,
  },
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],
      idBusiness: 0,
      list: [],
      listdatos: [],
      mode: 0,
      objectChart: null,
      contador: 0,
      listTpv: [],
      idTpv: -1,
      dateRangeOptions1: {
        firstDayOfWeek: 1,
      },
      ordenacionFecha: 0,
      ordenacionUsuario: 0,
      idTpvAMandar: " ",
      configTpv: false,

      respuesta: true,
    };
  },
  computed: {},
  methods: {
    cambioBusiness(idBusinessData, listTpv) {
      if (listTpv) {
        this.listTpv = listTpv;
      }

      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;
      this.idTpv = -1;
      this.list = [];
      //this.cambioTpv(this.idTpv);
      this.emitirConsulta();
    },

    emitirConsulta() {
      this.loading = Loading.service({ text: "Cargando..." });
      this.logOperario();
    },

    // cambioTpv(idTpvData, filtrar) {
    //   if (idTpvData != undefined) {
    //     this.idTpv = idTpvData;
    //   }

    //   this.idTpv = idTpvData;
    //   this.emitirConsulta();
    // },

    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          //vm.getSalesOperarios();
          vm.logOperario();
          vm.getTpv();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            for (let i = 0; i < response.data.result.length; i++) {
              vm.idsTPV.push(response.data.result[i].id);
            }

            vm.listCheckBoxTpv = response.data.result;

            for (let i = 0; i < response.data.result.length; i++) {
              let printername = {
                nameShow: response.data.result[i].nameShow,
                id: response.data.result[i].id,
              };

              vm.listTpv.push(printername);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    logOperario() {
      this.loading = Loading.service({ text: "Cargando..." });
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        this.loading.close();
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });

          this.loading.close();
        } else {
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          if (this.idTpv == -1) {
            this.idTpvAMandar = 0;
          } else {
            this.idTpvAMandar = this.idTpv;
          }

          var config = {
            params: {
              idBusiness: this.idBusiness,
              datefrom: moment(this.datefrom).startOf("day").unix(),
              dateto: moment(this.dateto).endOf("day").unix(),
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(this.$store.getters.apiUrl + "gestion/getLogUsuario", config)
            .then(function (response) {
              if (response.data.response) {
                vm.listdatos = response.data.result;
                vm.respuesta = true;
              } else if (response.data.response == false) {
                vm.respuesta = false;
              } else {
                swal({
                  title: $t("accesoDenegado"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
                vm.respuesta = false;
              }
              vm.loading.close();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    },
    sortedArrayFechaASC: function () {
      this.ordenacionFecha = 1;
      let vm = this;
      function compare(a, b) {
        let fecha1 = a.time;
        let fecha2 = b.time;
                    
        if (fecha1 <  fecha2)
          return -1;
        if (fecha1 > fecha2)
          return 1;
        return 0;
        
      }

      return this.listdatos.sort(compare);
    },
    sortedArrayFechaDESC: function () {
      this.ordenacionFecha = 0;
      let vm = this;
      function compare(a, b) {
        let fechaa = a.time;
        let fechab = b.time;
        if (fechaa >fechab)
          return -1;
        if (fechaa < fechab)
            return 1;
        return 0;
      }
      
      return this.listdatos.sort(compare);
    },
    sortedArrayUserASC: function () {
      this.ordenacionUsuario= 1;

      function compare(a, b) {
        if (a.firstName.toUpperCase() < b.firstName.toUpperCase()) return -1;
        if (a.firstName.toUpperCase() > b.firstName.toUpperCase()) return 1;
        return 0;
      }

      return this.listdatos.sort(compare);
    },

    sortedArrayUserDESC: function () {
      this.ordenacionUsuario = 0;

      function compare(a, b) {
        if (a.firstName.toUpperCase() > b.firstName.toUpperCase()) return -1;
        if (a.firstName.toUpperCase() < b.firstName.toUpperCase()) return 1;
        return 0;
      }

      return this.listdatos.sort(compare);
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Log/Log.vue